import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";

export const BuscadorModelosExcluidosMantenimiento = ({ setData, setLoader, loader }) => {
  const [state, setState] = useState({
    modelo: "",
    tipo: "I - Incluir",
  });

  const onGuardar = () => {
    if (state.modelo === "") {
      Swal.fire("SERVICIO", "Favor de agregar el modelo para la regla", "info");
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `DashboardPostventa/ExcluirModeloServicio?modelo=${state.modelo}&tipo=${state.tipo}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire({
          title: "SERVICIO",
          text: "Regla registrada con exito",
          icon: "success",
          customClass: {
            container: "mi-superpoop",
          },
        });
        setData(result);
        setState({
          modelo: "",
          tipo: "I - Incluir",
        });
        return;
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("SERVICIO", JSON.stringify(error), "error");
        return;
      });
  };

  return (
    <div className="listado-precios-usados-buscador-container">
      <div className="listado-clientes-gestionar-header-control">
        <TextField
          color="success"
          fullWidth
          size="small"
          value={state.modelo}
          onChange={({ target }) =>
            setState({ ...state, modelo: target.value })
          }
          placeholder="Numero de serie"
        />
        <Autocomplete
          value={state.tipo}
          onChange={(event, newValue) => {
            setState({ ...state, tipo: newValue }); 
          }}
          sx={{ mt: 2 }}
          options={["I - Incluir", "E - Excluir"]}
          renderInput={(params) => (
            <TextField {...params} label="Tipo" variant="outlined" />
          )}
        />
        <div className="btn-serviciomdlguardar" onClick={() => onGuardar()}>
          Guardar
        </div>
      </div>
    </div>
  );
};
